import { Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-black-deep text-gray-400 border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          
          <div className="md:col-span-1">
            <div className="flex items-center gap-4 mb-6">
              <img src="/assets/logo_v2.webp" alt="Icone L'art du Ménage" className="h-20 w-auto object-contain brightness-0 invert opacity-90" width="400" height="150" />
              <div className="flex flex-col">
                <div className="font-serif text-xl tracking-widest font-bold text-gold-500">
                  {t('footer.brandTitle')}
                </div>
                <div className="font-script text-lg text-white mt-1">
                  {t('footer.brandSubtitle')}
                </div>
              </div>
            </div>
            <p className="text-sm font-light mb-6">
              {t('footer.brandDesc')}
            </p>
            <div className="flex space-x-4">
              <a href="tel:+33123456789" aria-label={t('footer.callUs', { defaultValue: 'Appelez-nous' })} className="text-gray-400 hover:text-gold-400 transition-colors">
                <Phone size={20} />
              </a>
              <a href="mailto:contact@lartdumenage.fr" aria-label={t('footer.emailUs', { defaultValue: 'Envoyez-nous un email' })} className="text-gray-400 hover:text-gold-400 transition-colors">
                <Mail size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-serif uppercase tracking-wider text-sm mb-6">{t('footer.col1Title')}</h4>
            <ul className="space-y-3 font-light text-sm">
              <li><Link to="/legal" className="hover:text-gold-400 transition-colors">{t('footer.col1Mentions')}</Link></li>
              <li><Link to="/legal" className="hover:text-gold-400 transition-colors">{t('footer.col1Privacy')}</Link></li>
              <li><Link to="/cgv" className="hover:text-gold-400 transition-colors">{t('footer.col1Cgv')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-serif uppercase tracking-wider text-sm mb-6">{t('footer.col2Title')}</h4>
            <ul className="space-y-3 font-light text-sm">
              <li><Link to="/forfaits" className="hover:text-gold-400 transition-colors">{t('footer.col2Packages')}</Link></li>
              <li><Link to="/soin-du-linge" className="hover:text-gold-400 transition-colors">{t('footer.col2Laundry')}</Link></li>
              <li><span className="text-white font-medium">{t('footer.col2Zones')}</span></li>
              <li className="pl-3 border-l border-gold-500/30"><Link to="/villes/asnieres-sur-seine" className="hover:text-gold-400 transition-colors">Asnières-sur-Seine</Link></li>
              <li className="pl-3 border-l border-gold-500/30"><Link to="/villes/levallois-perret" className="hover:text-gold-400 transition-colors">Levallois-Perret</Link></li>
              <li className="pl-3 border-l border-gold-500/30"><Link to="/villes/neuilly-sur-seine" className="hover:text-gold-400 transition-colors">Neuilly-sur-Seine</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-serif uppercase tracking-wider text-sm mb-6">{t('footer.col3Title')}</h4>
            <ul className="space-y-3 font-light text-sm">
              <li><Link to="/login" className="hover:text-gold-400 transition-colors">{t('footer.col3Vip')}</Link></li>
              <li><Link to="/faq" className="hover:text-gold-400 transition-colors">{t('footer.col3Faq')}</Link></li>
              <li><Link to="/engagements" className="hover:text-gold-400 transition-colors">{t('footer.col3Commitments')}</Link></li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs font-light">
          <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/legal" className="hover:text-gold-400 transition-colors">{t('footer.bottomMentions')}</Link>
            <Link to="/legal" className="hover:text-gold-400 transition-colors">{t('footer.bottomPrivacy')}</Link>
            <Link to="/cgv" className="hover:text-gold-400 transition-colors">{t('footer.bottomCgv')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
